import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PremiumProvider } from './contexts/PremiumContext';

// Pages
import Home from './pages/Home';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import Dashboard from './pages/Dashboard';
import CreateTest from './pages/CreateTest';
import TestDetail from './pages/TestDetail';
import ParticipantTest from './pages/ParticipantTest';
import Premium from './pages/Premium';
import Profile from './pages/Profile';
import StitchHeader from './components/StitchHeader';

// Styles
import './App.css';
import './styles/StitchTheme.css';
import './styles/CreateTestStitch.css';
import './styles/StitchHeaders.css';

function App() {
  return (
    <Router>
      <AuthProvider>
        <PremiumProvider>
          <AppLayout />
        </PremiumProvider>
      </AuthProvider>
    </Router>
  );
}

function AppLayout() {
  const location = useLocation();
  const path = location.pathname;
  const hasPageHeader = path === '/' || path === '/create' || path === '/dashboard' || path === '/premium' || path === '/profile' || path.startsWith('/test/');

  return (
    <div className="app">
      {!hasPageHeader && <StitchHeader />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/create" element={<CreateTest />} />
        <Route path="/test/:testId" element={<TestDetail />} />
        <Route path="/t/:testUuid" element={<ParticipantTest />} />
        <Route path="/premium" element={<Premium />} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

// Protected Route Component
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

export default App;
